import { useCallback, useEffect } from 'react';
import { EnumValues } from '../types/enums';

export const IFRAME_MESSAGE_TYPES = {
  REQUIRE_AUTH: 'REQUIRE_AUTH',
} as const;

type MessageType = EnumValues<typeof IFRAME_MESSAGE_TYPES>;

type MessagePayloadMap = {
  [IFRAME_MESSAGE_TYPES.REQUIRE_AUTH]: null;
};

type IFrameMessage<T extends MessageType> = {
  type: T;
} & MessagePayloadMap[T];

const useIFrameMessage = <T extends MessageType>(messageType: T, handler: (data: IFrameMessage<T>) => void) => {
  const handleMessage = useCallback(
    (event: MessageEvent) => {
      if (event.data?.type === messageType) {
        handler(event.data);
      }
    },
    [messageType, handler]
  );

  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [handleMessage]);
};

export default useIFrameMessage;
